/* ==========================================================================
   International Registry of Lethal Hands - For Her landing page
   Sticky phone CTA: shows once the hero button has scrolled away,
   hides again when the final call to action is on screen.
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lhhReady === 'true') return;
    root.dataset.lhhReady = 'true';

    var sticky = root.querySelector('[data-lhh-sticky]');
    var heroCta = root.querySelector('[data-lhh-hero-cta]');
    var finalSection = root.querySelector('[data-lhh-final]');
    if (!sticky || !heroCta || !('IntersectionObserver' in window)) return;

    var heroVisible = true;
    var finalVisible = false;
    var link = sticky.querySelector('a');

    function update() {
      var show = !heroVisible && !finalVisible;
      sticky.classList.toggle('is-shown', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === heroCta) heroVisible = e.isIntersecting;
        if (e.target === finalSection) finalVisible = e.isIntersecting;
      });
      update();
    }).observe(heroCta);

    if (finalSection) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }).observe(finalSection);
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-lhh]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
